import { Parentheses } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ParenthesesIcon = createLucideIcon(Parentheses);
